import React from 'react';
import { CardTitle } from '@/components/ui/card';

export interface ErpCardTitleProps {
  className?: string;
  children?: React.ReactNode;
}
const ErpCardTitle: React.FC<ErpCardTitleProps> = ({ className, children, ...props }) => (
  <CardTitle className={className} {...props}>{children}</CardTitle>
);
export default ErpCardTitle;
